import axios from 'axios';
import { API_BASE } from '../config';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Let the browser set multipart boundaries for FormData uploads.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// Prevents the session-expired event from firing more than once per expiry cycle.
let _sessionExpiredDispatched = false;

export const resetSessionExpiredFlag = () => {
  _sessionExpiredDispatched = false;
};

// Handle 401 responses globally — only evict session when the user is inside
// the app, not on the login/register pages where secondary background calls
// can transiently return 401 before the session is fully established.
// Instead of a hard page redirect (which would wipe unsaved form data), we
// dispatch an event so AuthContext can show a re-login modal overlay.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const onAuthPage = ['/login', '/register'].some((p) =>
        window.location.pathname === p || window.location.pathname.startsWith(p + '/')
      );
      if (!onAuthPage && !_sessionExpiredDispatched) {
        _sessionExpiredDispatched = true;
        // Clear the expired token so subsequent requests don't loop on 401.
        localStorage.removeItem('token');
        // Signal the app to show a re-login modal without unmounting the page.
        window.dispatchEvent(new CustomEvent('journey:session-expired'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
